import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createProject,
  getActiveProjects,
  getAllProjectsCount,
  getCompletedProjects,
  getCompletedProjectsCount,
  getNgoProjects,
  getSingleProject,
  projectAddToFavorite,
  projectRemoveFromFavorite,
  projectUpdate,
} from "appState/api/project/project";

export const createNewProject = createAsyncThunk(
  "project/createNewProject",
  createProject
);
export const updateProject = createAsyncThunk(
  "project/updateProject",
  projectUpdate
);
export const getProjects = createAsyncThunk(
  "project/getProjects",
  getNgoProjects
);
export const getProject = createAsyncThunk(
  "project/getProject",
  getSingleProject
);
export const getCountAllProject = createAsyncThunk(
  "project/getCountAllProject",
  getAllProjectsCount
);
export const getAllCompletedProjects = createAsyncThunk(
  "project/getAllCompletedProjects",
  getCompletedProjects
);
export const getAllActiveProject = createAsyncThunk(
  "project/getAllActiveProject",
  getActiveProjects
);
export const getCountCompletedProject = createAsyncThunk(
  "project/getCountCompletedProject",
  getCompletedProjectsCount
);
export const addProjectToFavorite = createAsyncThunk(
  "project/addProjectToFavorite",
  projectAddToFavorite
);
export const removeProjectFromFavorite = createAsyncThunk(
  "project/removeProjectFromFavorite",
  projectRemoveFromFavorite
);

const initialState = {
  isLoading: false,
  projects: [],
  project: null,
  completedProjects: [],
  completedProjectsCount: null,
  projectsCount: null,
  activeProjects: [],
  activeProjectsCount: [],
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createNewProject.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createNewProject.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createNewProject.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateProject.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateProject.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateProject.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getProjects.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProjects.fulfilled, (state, action) => {
      state.isLoading = false;
      state.projects = action.payload?.data;
      state.projectsCount = action.payload?.data?.length;
    });
    builder.addCase(getProjects.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getProject.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProject.fulfilled, (state, action) => {
      state.isLoading = false;
      state.project = action.payload?.data?.project;
    });
    builder.addCase(getProject.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getAllCompletedProjects.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllCompletedProjects.fulfilled, (state, action) => {
      state.isLoading = false;
      state.completedProjects = action.payload?.data;
      state.completedProjectsCount = action.payload?.data?.length;
    });
    builder.addCase(getAllCompletedProjects.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getAllActiveProject.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllActiveProject.fulfilled, (state, action) => {
      state.isLoading = false;
      state.activeProjects = action.payload?.data;
      state.activeProjectsCount = action.payload?.data?.length;
    });
    builder.addCase(getAllActiveProject.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(addProjectToFavorite.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addProjectToFavorite.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(addProjectToFavorite.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(removeProjectFromFavorite.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(removeProjectFromFavorite.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(removeProjectFromFavorite.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default projectSlice.reducer;
